(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gallery-slider"] && !Shopify.designMode) return;
  try {
    class GallerySliderComponent extends HTMLElement {
    connectedCallback() {
      this.column = this.querySelector('.gallery-slider__top-images');

      this.#measure();
      this.resizeObserver = new ResizeObserver(() => {
        this.#measure();
        this.swiper?.update();
      });
      if (this.column) this.resizeObserver.observe(this.column);

      this.#whenSwiperReady().then(() => this.#init());
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    /* Slides are sized off the grid column, not the full-bleed swiper, so mobile can peek both sides */
    #measure() {
      // clientWidth, not 100vw — vw counts the scrollbar and the bleed would overshoot into a horizontal scroll
      this.style.setProperty('--gs-viewport-w', `${document.documentElement.clientWidth}px`);

      if (!this.column) return;
      this.style.setProperty('--gs-slide-w', `${this.column.offsetWidth}px`);
    }

    #whenSwiperReady() {
      if (window.Swiper) return Promise.resolve();

      return new Promise((resolve) => {
        const check = () => (window.Swiper ? resolve() : requestAnimationFrame(check));
        check();
      });
    }

    #init() {
      const container = this.querySelector('.gallery-slider__swiper');
      if (!container || this.swiper || !this.isConnected) return;

      this.swiper = new window.Swiper(container, {
        speed: 500,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        pagination: {
          el: this.querySelector('.gallery-slider__dots'),
          clickable: true,
        },
        navigation: {
          prevEl: this.querySelector('.gallery-slider__arrow--prev'),
          nextEl: this.querySelector('.gallery-slider__arrow--next'),
        },
        breakpoints: {
          990: {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
          },
        },
      });
    }
  }

  if (!customElements.get('gallery-slider-component')) {
    customElements.define('gallery-slider-component', GallerySliderComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-mosaic"] && !Shopify.designMode) return;
  try {
    class ImageMosaicComponent extends HTMLElement {
    #items = [];
    #visible = false;
    #ticking = false;
    #mobileQuery = matchMedia('(max-width: 989px)');
    #observer;

    connectedCallback() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.#items = this.#collect();
      if (!this.#items.length) return;

      this.#observer = new IntersectionObserver(
        (entries) => {
          this.#visible = entries[0].isIntersecting;
          if (this.#visible) this.#onScroll();
        },
        { rootMargin: '15% 0px' }
      );
      this.#observer.observe(this);

      // Capture phase: above 990px the scroller is .page-wrapper, and scroll doesn't bubble
      window.addEventListener('scroll', this.#onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.#onScroll, { passive: true });

      this.#onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.#onScroll, { capture: true });
      window.removeEventListener('resize', this.#onScroll);
      this.#observer?.disconnect();
    }

    // One entry per drift value: an ungrouped cell drifts alone, a group drifts off its first cell
    #collect() {
      const entries = [];
      const groups = new Map();

      for (const el of this.querySelectorAll('[data-parallax-speed]')) {
        const key = el.dataset.parallaxGroup;
        const existing = key && groups.get(key);
        if (existing) {
          existing.cells.push(el);
          continue;
        }

        const entry = { anchor: el, cells: [el], speed: parseFloat(el.dataset.parallaxSpeed) || 0 };
        if (key) groups.set(key, entry);
        entries.push(entry);
      }

      return entries;
    }

    #onScroll = () => {
      if (!this.#visible || this.#ticking) return;
      this.#ticking = true;

      requestAnimationFrame(() => {
        const viewportMid = window.innerHeight / 2;
        const factor = this.#mobileQuery.matches ? 0.5 : 1;

        for (const { anchor, cells, speed } of this.#items) {
          const rect = anchor.getBoundingClientRect();
          const elementMid = rect.top + rect.height / 2;
          // Distance from viewport centre × speed — the gap shrinks as the page scrolls down, so cells drift up
          const y = (elementMid - viewportMid) * speed * factor;
          const value = `${y.toFixed(1)}px`;
          for (const cell of cells) cell.style.setProperty('--im-parallax-y', value);
        }

        this.#ticking = false;
      });
    };
  }

  if (!customElements.get('image-mosaic-component')) {
    customElements.define('image-mosaic-component', ImageMosaicComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["overlapping-sliders"] && !Shopify.designMode) return;
  try {
    class OverlappingSlidersComponent extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll(':scope > .gallery-slider'));
      if (this.cards.length === 0) return;

      this.maxScale = (parseFloat(this.dataset.scale) || 0) / 100;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = window.matchMedia('(min-width: 990px)');

      this.resizeObserver = new ResizeObserver(() => {
        this.#measure();
        this.#update();
      });
      this.cards.forEach((card) => this.resizeObserver.observe(card));

      // Capture phase: above 990px the scroller is .page-wrapper, and scroll doesn't bubble
      this.onScroll = () => this.#update();
      document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.#measure();
      this.#update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    /* Publishes card height so CSS can clamp the sticky offset; the clamp itself lives in the stylesheet */
    #measure() {
      this.cards.forEach((card) => {
        card.style.setProperty('--os-card-h', `${card.offsetHeight}px`);
      });
    }

    #update() {
      if (!this.desktop.matches || this.reducedMotion.matches || this.maxScale === 0) return;

      const viewport = window.innerHeight;

      // Read every rect before writing, or each write forces the next read to reflow
      const tops = this.cards.map((card) => card.getBoundingClientRect().top);

      this.cards.forEach((card, index) => {
        if (index === this.cards.length - 1) {
          card.style.setProperty('--os-scale', '1');
          card.style.setProperty('--os-opacity', '1');
          return;
        }

        const progress = Math.min(1, Math.max(0, 1 - tops[index + 1] / viewport));

        card.style.setProperty('--os-scale', `${1 - progress * this.maxScale}`);
        card.style.setProperty('--os-opacity', `${1 - Math.max(0, (progress - 1 / 3) * 0.5)}`);
      });
    }
  }

  if (!customElements.get('overlapping-sliders-component')) {
    customElements.define('overlapping-sliders-component', OverlappingSlidersComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
